import styled from '@emotion/styled';

/* next/image layout="fill" + objectFit="contain"과 동일한 렌더 박스를 재현한다 */
export const PageImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;

  -webkit-user-drag: none;

  user-select: none;

  &.is-blind {
    filter: blur(8px);
  }
`;
